import { Injectable } from "@angular/core";
import { environment } from "environments/environment";
import { ApiEvsService } from "app/common/services/ApiEvs.service";
import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
} from "@angular/common/http";
import { Observable } from "rxjs/Observable";
import { Headers, Http } from "@angular/http";

@Injectable()
export class PointOfSaleService {
  headers: Headers;
  url = environment.api_evs;
  url2 = environment.api_evs + "/qr-core-aps";

  constructor(private http: Http, private apiEvsService: ApiEvsService) {
    const token = localStorage.getItem("Access-Token");
    this.headers = new Headers({
      "Accept-Language": localStorage.getItem("lang") || "vi",
      "Content-Type": "application/json",
      Authorization: `${token}`,
    });
  }

  getList(productId?: any, query?: any): Observable<any> {
    return this.http
      .get(`${this.url2}/product_store/${productId}`, {
        headers: this.headers,
        params: query,
      })
      .map((res) => {
        return res.json();
      })
      .catch((error: any) => {
        throw this.apiEvsService.checkErr(error);
      });
  }

  detailStoreSale(storeId?: any): Observable<any> {
    return this.http.get(`${this.url2}/product_store/${storeId}`, {
      headers: this.headers,
    }).map((res) => {
      return res.json();
    })
      .catch((error: any) => {
        throw this.apiEvsService.checkErr(error);
      })
  }

  addNewStoreSale(productId?:any,body?: any): Observable<any> {
    return this.http.post(`${this.url2}/product_store/${productId}`, body, {
      headers: this.headers,
    }).map((res) => {
      return res.json();
    })
      .catch((error: any) => {
        throw this.apiEvsService.checkErr(error);
      })
  }

  updateStoreSale(body?: any): Observable<any> {
    return this.http.put(`${this.url2}/product_store`, body, {
      headers: this.headers,
    }).map((res) => {
      return res.json();
    })
      .catch((error: any) => {
        throw this.apiEvsService.checkErr(error);
      })
  }

  deleteSoreSale(storeId): Observable<any> {
    return this.http.delete(`${this.url2}/product_store/${storeId}`, {
      headers: this.headers,
    }).map((res) => {
      return res.json();
    })
      ._catch((error: any) => {
        throw this.apiEvsService.checkErr(error);
      })
  }

  uploadFileProduct(id?: any, file?: any): Observable<any> {
    this.headers.delete("Content-Type");
    if (localStorage.getItem("Access-Token")) {
      this.headers.set("authorization", localStorage.getItem("Access-Token"));
    }
    let formData = new FormData();
    formData.append("file", file, file.name);
    return this.http
      .post(`${this.url2}/product_store/import/${id}`, formData, { headers: this.headers })
      .map((res) => {
        return res.json();
      })
      .catch((error: any) => {
        throw error.json();
      });
  }

}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/evs/product/product-setting/services/point_of_sale.service.ts